// Shared timezone list — single source of truth for the Onboarding and
// Settings timezone selectors (previously duplicated inline in Settings,
// causing the two to drift). A curated, readable set rather than the full
// ~400 IANA zones; buildTimezoneGroups() below injects the browser's exact
// detected zone if it isn't already one of these, so nothing is ever lost.
export const TIMEZONE_GROUPS = [
  {
    label: "Canada",
    options: [
      { value: "America/Toronto",   label: "Toronto / Ottawa / Montreal (ET)" },
      { value: "America/Vancouver", label: "Vancouver (PT)" },
      { value: "America/Edmonton",  label: "Edmonton / Calgary (MT)" },
      { value: "America/Winnipeg",  label: "Winnipeg (CT)" },
      { value: "America/Halifax",   label: "Halifax (AT)" },
      { value: "America/St_Johns",  label: "St. John's (NT)" },
    ],
  },
  {
    label: "United States",
    options: [
      { value: "America/New_York",    label: "New York / Miami (ET)" },
      { value: "America/Chicago",     label: "Chicago / Dallas (CT)" },
      { value: "America/Denver",      label: "Denver / Phoenix (MT)" },
      { value: "America/Los_Angeles", label: "Los Angeles / Seattle (PT)" },
      { value: "Pacific/Honolulu",    label: "Honolulu (HT)" },
    ],
  },
  {
    label: "Europe",
    options: [
      { value: "Europe/London",    label: "London / Edinburgh (GMT/BST)" },
      { value: "Europe/Amsterdam", label: "Amsterdam (CET/CEST)" },
      { value: "Europe/Paris",     label: "Paris / Berlin / Rome (CET/CEST)" },
      { value: "Europe/Istanbul",  label: "Istanbul (TRT)" },
    ],
  },
  {
    label: "Middle East & Asia",
    options: [
      { value: "Asia/Dubai",     label: "Dubai (GST)" },
      { value: "Asia/Karachi",   label: "Karachi (PKT)" },
      { value: "Asia/Kolkata",   label: "Mumbai / Delhi (IST)" },
      { value: "Asia/Dhaka",     label: "Dhaka (BST)" },
      { value: "Asia/Singapore", label: "Singapore (SGT)" },
      { value: "Asia/Tokyo",     label: "Tokyo (JST)" },
    ],
  },
  {
    label: "Australia",
    options: [
      { value: "Australia/Sydney", label: "Sydney / Melbourne (AEST)" },
      { value: "Australia/Perth",  label: "Perth (AWST)" },
    ],
  },
];

// The visitor's own device timezone (IANA name, e.g. "Europe/Amsterdam").
// Every evergreen browser supports this; wrapped defensively regardless.
export function detectBrowserTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch {
    return null;
  }
}

// Returns TIMEZONE_GROUPS, plus — if the detected/current zone isn't already
// in the curated list — a "Detected" group injected at the top so it's never
// silently lost or mismatched to the wrong city.
export function buildTimezoneGroups(extraZone) {
  if (!extraZone) return TIMEZONE_GROUPS;
  const alreadyListed = TIMEZONE_GROUPS.some(g => g.options.some(o => o.value === extraZone));
  if (alreadyListed) return TIMEZONE_GROUPS;
  return [
    { label: "Detected", options: [{ value: extraZone, label: extraZone.replace(/_/g, " ") }] },
    ...TIMEZONE_GROUPS,
  ];
}
